// Money helpers: values are stored server-side as integer minor units (qepik).
// Never do arithmetic in floats.
export function fmtMoney(minor: number, currency: string = "AZN"): string {
    const sign = minor < 0 ? "-" : "";
    const abs = Math.abs(minor);
    const whole = Math.floor(abs / 100).toString();
    const frac = (abs % 100).toString().padStart(2, "0");
    // Thousands separator with narrow no-break space
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, "\u202F");
    return `${sign}${grouped},${frac} ${currency}`;
}
